import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { motion } from "framer-motion";
// import { setVotingSys, setMultiplicadorSys, addIssuesSys } from '../features/metadata/MetadataLogic'

export default function VotingRoom() {
  const idRoom = 1;

  // REDUX ----------------------------------------------------------
  // Para obtener y modificar la data del individuo en Redux
  const jsonMetadata = useSelector((state) => state.jsonMetadata.value);
  const dispatch = useDispatch();

  const [voto, setVoto] = useState(0);
  const [indexIssue, setIndexIssue] = useState(0);

  const showCompo = {
    opacity: 1,
    display: "block",
  };
  const hideCompo = {
    opacity: 0,
    transitionEnd: {
      display: "none",
    },
  };
  const [displayIssues, setDisplayIssues] = useState(false);
  const totalIssues =
    jsonMetadata && Array.isArray(jsonMetadata.issues)
      ? jsonMetadata.issues.length
      : 0;
  var localIssues =
    jsonMetadata && Array.isArray(jsonMetadata.issues)
      ? jsonMetadata.issues
      : [];

  let navigate = useNavigate();

  useEffect(() => {
    if (!jsonMetadata || !Array.isArray(jsonMetadata.issues)) {
      navigate("/");
    }
  }, [jsonMetadata, navigate]);

  if (!jsonMetadata || !Array.isArray(jsonMetadata.issues)) {
    return null;
  }

  const routeChangeHome = () => {
    let path = "/";
    navigate(path);
  };

  if (totalIssues === undefined) {
    routeChangeHome();
  }

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 2 } }}
      exit={{ opacity: 0 }}
    >
      {/* Logica para mostrar los Issues o no */}
      <motion.div
        animate={displayIssues ? showCompo : hideCompo}
        style={{
          backgroundColor: "#1a2353",
          position: "fixed",
          width: "100%",
          zIndex: 1,
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          <span
            style={{
              color: "#FFFFFF",
              position: "absolute",
              padding: "10px 20px 20px 10px",
              left: 0,
              cursor: "pointer",
              backgroundColor: "#ff0000",
              borderRadius: "0 0px 50px 0",
            }}
            onClick={() => setDisplayIssues(!displayIssues)}
          >
            ///
          </span>
        </div>
        <div class="container" style={{ marginTop: 20 }}>
          <div class="row">
            {jsonMetadata.issues.map((element) => {
              const nombre =
                typeof element === "string" ? element : element.nombre;
              return (
                <motion.div
                  key={nombre}
                  whileHover={{ scale: 1.1 }}
                  whileTap={{
                    scale: 0.8,
                    borderRadius: "100%",
                  }}
                  class="col-sm-3 mb-3"
                >
                  <div class="card">
                    <div class="card-body">
                      <h3 class="card-title">{nombre}</h3>
                    </div>
                  </div>
                </motion.div>
              );
            })}
          </div>
        </div>
      </motion.div>
      {/* Personas conectadas a la votacion */}
      <div
        style={{
          position: "absolute",
          top: 0,
          right: 0,
          width: "50px",
          height: "100%",
          backgroundColor: "#191827",
        }}
      >
        {jsonMetadata.participantes.map((e) => {
          return (
            <div
              style={{
                textAlign: "center",
                margin: "0 auto",
                padding: "5px",
                borderRadius: "50px",
                backgroundColor: "#6fa1c2",
              }}
              title={e.nombre}
            >
              {e.nombre.substring(0, 1)}
            </div>
          );
        })}
      </div>

      {/* Issues de la votacion */}
      <nav class="nav justify-content-center">
        <span
          style={{
            color: "#FFFFFF",
            position: "absolute",
            padding: 10,
            left: 0,
            cursor: "pointer",
          }}
          onClick={() => setDisplayIssues(true)}
        >
          ///
        </span>

        <p
          style={{ color: "#FFFFFF", position: "absolute", marginTop: "10px" }}
        >
          {jsonMetadata.participantes[0].nombre}
        </p>
      </nav>

      <div className="App-header">
        <motion.div
          whileHover={{ scale: 1.1 }}
          whileTap={{
            scale: 0.8,
            borderRadius: "100%",
          }}
          className="col-sm-3 mb-3"
        >
          <div className="card">
            <div className="card-body">
              <h3 className="card-title" style={{ color: "#000000" }}>
                {typeof jsonMetadata.issues[indexIssue] === "string"
                  ? jsonMetadata.issues[indexIssue]
                  : jsonMetadata.issues[indexIssue].nombre}
              </h3>
            </div>
          </div>
        </motion.div>
      </div>

      {/* Opciones de cartas */}
      <div
        style={{
          bottom: 30,
          position: "fixed",
          width: "100%",
          display: "inline",
          textAlign: "center",
          color: "#FFFFFF",
        }}
      >
        <span
          style={{
            backgroundColor: "#FFFFFF",
            color: "#000000",
            padding: 10,
            borderRadius: 50,
          }}
        >
          {voto}
        </span>
        <p style={{ marginTop: "20px", marginBottom: "15px" }}>Cards</p>
        <div style={{ width: "100%" }}>
          {jsonMetadata.votingSystem.map((e) => {
            return (
              <motion.button
                whileHover={{
                  borderRadius: "50px",
                  color: "#000000",
                  scale: 1.1,
                  backgroundColor: "#FFFFFF",
                }}
                whileTap={{
                  scale: 0.8,
                  borderRadius: "100%",
                }}
                key={e}
                type="button"
                class="btn btn-primary"
                value={e}
                onClick={(element) => {
                  setVoto(element.target.value);
                }}
              >
                {e}
              </motion.button>
            );
          })}
        </div>
      </div>

      <div
        style={{
          bottom: 30,
          right: 30,
          position: "absolute",
          display: "inline",
          textAlign: "center",
          color: "#FFFFFF",
        }}
      >
        <motion.button
          whileHover={{
            borderRadius: "50px",
            color: "#000000",
            scale: 1.1,
            backgroundColor: "#FFFFFF",
          }}
          whileTap={{
            scale: 0.8,
            borderRadius: "100%",
          }}
          className="btn btn-primary"
          style={{
            backgroundColor: "#FFFFFF",
            color: "#000000",
            padding: 15,
            borderRadius: 70,
            fontSize: 18,
            fontWeight: "bold",
            border: "none",
            cursor: "pointer",
            transition: "all 0.3s ease",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
            "&:hover": {
              backgroundColor: "#e0e0e0",
              transform: "scale(1.05)",
              boxShadow: "0 6px 12px rgba(0, 0, 0, 0.3)",
            },
          }}
          onClick={() => {
            // Crear una copia de los issues
            const updatedIssues = [...localIssues];
            // Asegurarse de que el nombre sea siempre un string
            const issueActual = localIssues[indexIssue];
            const nombre =
              typeof issueActual === "string"
                ? issueActual
                : issueActual.nombre;
            updatedIssues[indexIssue] = {
              nombre,
              valor: { voto },
            };
            // Guardar en Redux
            dispatch(
              require("../features/metadata/MetadataLogic").addIssuesSys({
                issues: updatedIssues,
              })
            );
            // Avanzar al siguiente issue o ir a resultados
            if (indexIssue + 1 < totalIssues) {
              setIndexIssue(indexIssue + 1);
              setVoto(0);
            } else {
              // Obtener el multiplicador guardado en jsonMetadata
              const multiplicador = jsonMetadata && jsonMetadata.multiplicador
                ? parseFloat(jsonMetadata.multiplicador)
                : 1;

              // Procesar los issues para agregar el campo "horas"
              const issuesProcesados = updatedIssues.map((issue) => {
                // Obtener el voto (puede estar en issue.valor.voto o issue.valor)
                let votoBase = 0;
                if (issue && issue.valor && typeof issue.valor.voto !== "undefined") {
                  votoBase = parseFloat(issue.valor.voto);
                } else if (issue && issue.valor && typeof issue.valor !== "undefined") {
                  votoBase = parseFloat(issue.valor);
                }
                // Si el voto no es un número válido, dejarlo en 0
                if (isNaN(votoBase)) votoBase = 0;

                // Calcular las horas
                const horas = votoBase * multiplicador;

                // Retornar el issue con el campo "horas"
                return {
                  ...issue,
                  horas: horas,
                };
              });

              // Guardar los issues procesados en Redux
              dispatch(
                require("../features/metadata/MetadataLogic").addIssuesSys({
                  issues: issuesProcesados,
                })
              );
              navigate("/StatsOfMatch");
            }
          }}
        >
          Save Vote
        </motion.button>
      </div>
    </motion.div>
  );
}
